var map = {
	"./PIC.png": "1ga/",
	"./aiFx.png": "cYZO",
	"./aiRoutionPageBG.png": "MDbj",
	"./aiRutionPage.png": "Zw7p",
	"./back-bg.png": "fZpR",
	"./bg.jpg": "ctKR",
	"./bg_bottom.png": "sQVp",
	"./bg_top-1.png": "S3Xu",
	"./bg_top-2.png": "dqM2",
	"./bg_top.png": "wkSR",
	"./checksy.png": "n8XT",
	"./cuo.png": "dgsg",
	"./download_icon.png": "DWdy",
	"./dpDui.png": "ARlR",
	"./drum-down.png": "utqz",
	"./drum-up.png": "+OOV",
	"./dui.png": "ovJ0",
	"./duibaise.png": "hcKu",
	"./end-back.png": "A6Jz",
	"./end-bg.png": "iydp",
	"./end-dui.png": "aoWC",
	"./guoyin-logo.png": "nhLT",
	"./hiddenMail.png": "zDsg",
	"./img_loading_error.png": "m/d8",
	"./isPlaying.gif": "EP/8",
	"./join-yx1.png": "n7dx",
	"./join-yx2.png": "4pbT",
	"./join-yx3.png": "1MSX",
	"./join-yx4.png": "pRIy",
	"./join-yx5.png": "+2lQ",
	"./join-yx6.png": "HvpH",
	"./join-yx7.png": "UKXi",
	"./listNotNotxt.png": "uaCX",
	"./logo.png": "Z2Ou",
	"./mkf.png": "uwl1",
	"./moning-off.png": "RyXr",
	"./moning-on.png": "VACn",
	"./name.png": "gtgr",
	"./no70img.png": "ypqM",
	"./noData.png": "KrUZ",
	"./noPaying.png": "Jam2",
	"./opt.png": "oKht",
	"./password.png": "dCxc",
	"./play.png": "cUGd",
	"./rbg.png": "0Ckk",
	"./report-bg.png": "yJoq",
	"./report-buttom.png": "R+Qk",
	"./report-center.png": "WARQ",
	"./report-icon.png": "wfvB",
	"./rightJt.png": "YeYD",
	"./rightjiantou.png": "VwVq",
	"./signOkicon.png": "Y/ry",
	"./takingPictures.png": "5Ljf",
	"./timeoutimg.png": "8pQG",
	"./type-img.png": "HRO8",
	"./updataFile-button.png": "v3+m",
	"./updataFile-top.png": "wlwT",
	"./zhongOpt.png": "bm+n"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "L+QI";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*$
// module id = L+QI
// module chunks = 1